import React, { Component } from 'react';
import ListItem from '@material-ui/core/ListItem';
import Paper from '@material-ui/core/Paper';
import { withStyles } from '@material-ui/core/styles';
import { Theme } from '@material-ui/core/styles/createMuiTheme';
import CircularProgress from '@material-ui/core/CircularProgress';
import _ from 'lodash';
import cx from 'classnames';
import { MyPATLink } from '../../../common';
import{styles} from '../../styling/component/MilestoneDetails/MilestonePageCard'

import {
	WithStyles,
    createStyles,
    Typography,
    Grid,
    Button,
} from '@material-ui/core';

interface WithContentProps extends WithStyles<typeof styles>{
  cardDetails: any;
  cardFlag: string;
 
}

function ordinal_suffix_of(i:number) {
  var j = i % 10,
      k = i % 100;
  if (j == 1 && k != 11) {
      return i + "st";
  }
  if (j == 2 && k != 12) {
      return i + "nd";
  }
  if (j == 3 && k != 13) {
      return i + "rd";
  }
  return i + "th";
}

const MilestonePageCard = (props:WithContentProps) => {
  const {
    classes,
    cardDetails,
  } = props;
  let value = cardDetails;
  let rows = "";
  if(value)
  {
	   for (var k in value.contentTypes) {
		rows += ' ' + value.contentTypes[k] + ' ' + k + ' '
	  }
  }
  
  return(
          <> 
            <Grid item xs={2} className={classes.posRel}>
              <img width="120px;" height="120px;"  src={value.type === true ? "/assets/img/course/ds.png":"/assets/img/course/milestone-bg.png"} alt="book" />
                <Grid container className={classes.textBarNega}> {ordinal_suffix_of(value.selectedMilestoneIndex)}</Grid>
                <Grid container className={classes.textBarNega2}> {value?value.chapterCount:''}</Grid>
                <Grid container className={classes.textBarNega3}> Chapters</Grid>
            </Grid>
            <Grid item xs={12}>  
                <Grid container className={classes.leftDisplay}>
                  <Grid item xs={6}>
                    <Typography variant="body1" className={cx( classes.textEllipsis)}>
                  <img style={{filter: "invert(1)"}} src="/assets/img/course/group_4.png" alt="book" />&nbsp;
				              	<b>{value?value.number:''} {value?value.Duration:''}</b>&nbsp;
				           	Completion Date: {value?value.startDate:''}</Typography>
                  </Grid>
                  <Grid item xs={7}>
                    <Typography variant="body2" className={cx( classes.textEllipsis)}>{value?value.totalAssignment:''} Assignments </Typography>
                  </Grid>
                  <Grid item xs={12} className={classes.textEllipsis}>
                    <Typography variant="body1" className={classes.subTitle}>{rows}</Typography>
                  </Grid>
                  <Grid item xs={12}>
                    <Typography variant="body2" className={classes.subTitle}><b>Milestone Test  </b></Typography>
                  </Grid>
                  <Grid item xs={12}>
				    <img src="/assets/img/course/GoalIcon.png" alt="book" />
                    <Typography variant="body2" className={classes.subTitle}><b> Phase Test 1 </b></Typography>
                  </Grid>
                </Grid>
            </Grid>
          </>
  )
}

export default withStyles(styles)(MilestonePageCard);